const Modal = ({modal, setModal, url}) => (
  <picture className={`${modal["visible"] ? "modal" : "modal modal-hidden"}`}>
    <button className="modal-close"
      onClick={()=>{
        setModal({...modal, "visible": false})
      }}
    >
      <img src={`${process.env.PUBLIC_URL}/img/ui/btn_popup_close.png`} alt="" />
    </button>
    <button className={`left-arrow ${modal['current']===1 && "disabled"}`}
      onClick={()=>{
        setModal({...modal, 'current': modal["current"]-1})
      }}
    >
      <img src={`${process.env.PUBLIC_URL}/img/ui/btn_popup_prev.png`} alt="" />
    </button>
    <div className="modal-contents">
      <img src={`${process.env.PUBLIC_URL}/img/ss/${url.substring(0, url.indexOf('.'))}${modal["current"]}${url.substring(url.indexOf('.'), url.length)}`} alt="" />
    </div>
    <button className={`right-arrow ${modal['current']===modal.size && "disabled"}`}
      onClick={()=>{
        setModal({...modal, 'current': modal["current"]+1, url: `${url.substring(0, url.indexOf('.'))}${modal["current"]+1}${url.substring(url.indexOf('.'), url.length)}`})
      }}
    >
      <img src={`${process.env.PUBLIC_URL}/img/ui/btn_popup_next.png`} alt="" />
    </button>
  </picture>
)

export default Modal;